import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UserService } from '../../services/userService';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
    selector: 'app-change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {
    Error: boolean;
    Message: string;

    changePasswordForm: FormGroup;

    constructor(private formBulder: FormBuilder,
        private userService: UserService,
        private router: Router,
        private authService: AuthService
    ) {
    }

    ngOnInit() {
        this.buildForm();
    }

    buildForm() {
        this.changePasswordForm = this.formBulder.group({
            currentPassword: ['', Validators.required],
            password: ['', [Validators.required, Validators.pattern(new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[#$^+=!*()@%&]).{8,}$'))]],
            confirmPassword: ['', [Validators.required, Validators.pattern(new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[#$^+=!*()@%&]).{8,}$'))]],
        });
    }

    isMatch(): boolean {

        return this.changePasswordForm.controls['password'].value == this.changePasswordForm.controls['confirmPassword'].value;
    }

    IsValid(): boolean {
        return !this.changePasswordForm.invalid && this.isMatch();
    }

    changePassword(formData) {
        this.userService.changePassword(formData).subscribe(data => {
            if (data) {
                if (!this.authService.IsAuthenticated()) {
                    this.authService.authenticate();
                }
                else {
                    this.Error = false;
                    this.Message = "The Password has been changed!"
                }
            }
            else {
                this.Error = true;
                this.Message = "Error with changing the password!"
            }
        });
    }

}
